<template>

<div>

<ul class="content-list">
    <li v-for="content in contents" :class="`${current === content.path ? 'current':''}`">
        <a :href="`#/${content.path}`"> </a> {{content.title}}
    </li>
</ul>
</div>

</template>

<script>

import {mapState} from "vuex";

export default {
  data: () => ({

  }),
  props: {
    current:{
      default:function(){
        return 'seasons';
      }
    },
    contents:{
      default: function(){
        return [];
      }
    }
  },
  methods: {

  },
};
</script>
<style lang="scss">
    .content-list {

      padding-bottom:10px;

      display:flex;
      overflow-x:hidden;
     flex-wrap:wrap;

      @media(max-width:768px){
              overflow-x:scroll;
                flex-wrap:nowrap;
      }
      max-width:100%;
      & > li {
        
        &.current {
            background:rgba(0,0,0,0.7);
        }
        position:relative;
        & > a {
          z-index:2;
          position:absolute;
          width:100%;
          height:100%;
          top:0;
          left:0;
          right:0;
          bottom:0;
        }
        font-size:14px;
        border-radius:10px;
        margin: 0 15px 10px 0;
        padding:10px 10px;
        background:rgba(0,0,0,0.55);
        color:#fff;
        max-width: 100%;
        white-space: nowrap;
        height: 40px;
        border-radius: 10px;
        justify-content: center;
        align-items: center;
      }
    }
</style>
